import { render, staticRenderFns } from "./ProductCardHorizontalOffer.vue?vue&type=template&id=7bb43e06&"
import script from "./ProductCardHorizontalOffer.vue?vue&type=script&lang=js&"
export * from "./ProductCardHorizontalOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports